<app-project-calculation-form-expenditure
  (selectedExpenditureRateOptionChanged$)="this.expenditureRateOptionChanged($event)"
>
</app-project-calculation-form-expenditure>

<div class="row gx-5">
  <div class="col-8">
    <hr class="k-my-10" />
  </div>
</div>

<app-project-calculation-form-budget
  (selectedBudgetOptionChanged)="this.budgetOptionChanged($event)"
/>

<app-project-calculation-form-reset-budget
  [selectedBudgetRateOptionChanged]="selectedBudgetOptionChanged$"
/>
